import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import * as styles from './index.module.css'
import { GatsbyImage } from 'gatsby-plugin-image'
import Slider from 'react-slick'
import Modal from 'react-modal'
import FoldableSection from '../FoldableSection'
import Plus from '../../../static/plus.png'
import Close from '../../../static/blackClose.png'
import ProductTile from './ProductTile'
import Button from '../Button/'
import Sticky from 'react-stickynode'
import DarkCheck from '../../../static/darkCheckMark.png'
import LeftArrow from '../../../static/leftArrow.png'
import RightArrow from '../../../static/rightArrow.png'
import BlackPlus from '../../../static/BlackPlus.png'
import Link from '../Link'

const prepareComparisonSection = (comp) => {
  const sections = {}
  const sectionOrder = []
  comp.subtitle.subtitle.split('\n\n').forEach((section) => {
    let chunks = section.split('::')
    sectionOrder.push(chunks[0])
    sections[chunks[0]] = chunks[1].split(',')
  })
  return [sections, sectionOrder]
}

const prepareProducts = (comps) => {
  const products = {}
  const productOrder = []
  const selectedProducts = []
  comps.forEach((comp) => {
    let productName = comp.title.split(';')[0]

    products[productName] = {
      label: '',
      selectionColor: '',
      specs: {},
      icon: '',
      images: [],
    }
    let product = products[productName]
    productOrder.push(productName)
    if (
      comp.title.split(';').length > 1 &&
      comp.title.split(';')[1] == 'selected'
    ) {
      selectedProducts.push(productName)
    }
    const sections = comp.subtitle.subtitle.split('\n\n')
    product.label = sections[0].split(';')[0]
    product.icon = comp.image.file.url
    product.desc = comp.image.description || ''

    product.selectionColor = sections[0].split(';')[1]

    if (comp.secondaryImages != null && comp.secondaryImages.length > 0) {
      product.images = comp.secondaryImages.map((image) => {
        return { src: image.fluid, description: image.description }
      })
    } else {
      product.images = []
    }

    // populate product specs organized by different sections
    sections.slice(1).forEach((section, idx) => {
      let sectionName = section.split('::')[0]
      product.specs[sectionName] = []

      let delimiter = ';'
      if (idx === 3) {
        delimiter = '&'
      }
      product.specs[sectionName] = section.split('::')[1].split(delimiter)
    })
  })
  return [products, productOrder, selectedProducts]
}

export default class ProductComparison extends Component {
  constructor(props) {
    super(props)
    this.sections = {}
    this.titleBarRef = React.createRef()
    this.sectionOrder = []
    this.initialSelectedProducts = []
    this.maxAllowed = 5
    this.maxMobileAllowed = 2
    this.minAllowed = 3
    this.minMobileAllowed = 1
    ;[this.sections, this.sectionOrder] = prepareComparisonSection(
      props.components[0]
    )
    ;[this.products, this.productOrder, this.initialSelectedProducts] =
      prepareProducts(props.components.slice(1))

    this.pointCloudMetaLabels = ['Sensor', 'data', 'data', 'location']

    this.state = {
      modalIsOpen: false,
      newSelection: this.initialSelectedProducts,
      newMobileSelection: this.initialSelectedProducts.slice(0, 2),
      selectedProducts: this.initialSelectedProducts,
      mobileSelectedProducts: this.initialSelectedProducts.slice(0, 2),
      hoveredProductIndex: -1,
      imageSliderIsOpen: false,
      imagesForSlider: [],
      imageSliderImageIndex: -1,
      prevScrollpos: 0,
      toggleHeight: 90,
      stickyHeaderTop: 0,
    }
  }

  sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 2000,
    dotsClass: `slick-dots ${styles.slickDots}`,
    afterChange: (index) => {
      this.setState({ imageSliderImageIndex: index })
    },
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const { prevScrollpos, toggleHeight } = this.state

    const currentScrollPos = window.pageYOffset
    const visible =
      currentScrollPos < toggleHeight || prevScrollpos > currentScrollPos
    this.setState({
      stickyHeaderTop: visible ? 90 : 0,
      prevScrollpos: currentScrollPos,
    })
  }
  openModal = () => {
    this.setState({ modalIsOpen: true })
  }
  closeImageSlider = () => {
    this.setState({
      imageSliderIsOpen: false,
      imagesForSlider: [],
      imageSliderImageIndex: -1,
    })
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false })
  }

  onPickerClose = () => {
    this.setState({ newSelection: this.state.selectedProducts })
  }

  nextImage = () => {
    if (
      this.state.imageSliderImageIndex ===
      this.state.imagesForSlider.length - 1
    ) {
      this.setState({ imageSliderImageIndex: 0 })
    } else {
      this.setState({
        imageSliderImageIndex: this.state.imageSliderImageIndex + 1,
      })
    }
  }

  prevImage = () => {
    if (this.state.imageSliderImageIndex === 0) {
      this.setState({
        imageSliderImageIndex: this.state.imagesForSlider.length - 1,
      })
    } else {
      this.setState({
        imageSliderImageIndex: this.state.imageSliderImageIndex - 1,
      })
    }
  }

  getCellContent = (val) => {
    if (!val) {
      return val
    }
    const fragments = val.split('%%')
    if (fragments.length === 1) {
      if (val === 'yes') {
        return (
          <img src={DarkCheck} className={styles.checkMark} alt="check mark" />
        )
      } else {
        let multiLineCandidates = fragments[0].split('\\r\\n')
        return (
          <div>
            {multiLineCandidates.map((c, idx) => (
              <div key={idx} className="random-cc">
                {c}
              </div>
            ))}
          </div>
        )
      }
    } else {
      if (fragments[0] === 'yes') {
        return (
          <Link
            to={fragments[1]}
            children={
              <img
                src={DarkCheck}
                className={styles.checkMark}
                alt="check mark"
              />
            }
          ></Link>
        )
      } else {
        let multiLineCandidates = fragments[0].split('\\r\\n')

        return (
          <Link
            to={fragments[1]}
            children={multiLineCandidates.map((c, idx) => (
              <div key={idx} className="random-cc">
                {c}
              </div>
            ))}
          ></Link>
        )
      }
    }
  }

  handleContainerScroll = (e) => {
    let element = e.target
    this.titleBarRef.current.scrollLeft = element.scrollLeft
  }

  render() {
    const isMobile = typeof window !== `undefined` && window.innerWidth <= 767
    let productsToCompare = !isMobile
      ? this.state.selectedProducts
      : this.state.mobileSelectedProducts

    let specSections = this.sectionOrder.map((category, idx) => {
      let comparedAttributes = this.sections[category].map((specName, idx) => (
        <div className={styles.comparisonRow} key={idx}>
          <div className={styles.specName}>{this.getCellContent(specName)}</div>
          {productsToCompare.map((product, index) => {
            return (
              <div className={styles.specValue} key={index}>
                {specName == 'Point clouds' &&
                  this.products[product].images.length > 0 && (
                    <div
                      className={styles.imageGalleryTrigger}
                      onClick={() => {
                        this.setState({
                          imagesForSlider: this.products[product].images,
                          imageSliderIsOpen: true,
                          imageSliderImageIndex: 0,
                        })
                      }}
                    >{`${product} data`}</div>
                  )}
                {specName !== 'Point clouds' && (
                  <React.Fragment>
                    {this.products[product]['specs'][category] != null &&
                      this.getCellContent(
                        this.products[product]['specs'][category][idx]
                      )}
                  </React.Fragment>
                )}
              </div>
            )
          })}
        </div>
      ))
      return (
        <FoldableSection
          key={idx}
          title={category}
          initiallyOpened={idx === 0 ? true : false}
          disableXScroll={true}
        >
          <div className={styles.comparisonSection}>{comparedAttributes}</div>
        </FoldableSection>
      )
    })

    let comparisonTitleBar = this.state.selectedProducts.map((product, idx) => (
      <div
        className={styles.productTitle}
        onMouseEnter={() => {
          this.setState({ hoveredProductIndex: idx })
        }}
        onMouseLeave={() => {
          this.setState({ hoveredProductIndex: -1 })
        }}
        key={idx}
      >
        {this.state.hoveredProductIndex === idx && (
          <div
            className={styles.removeButtonContainer}
            onClick={() => {
              if (this.state.selectedProducts.length >= this.minAllowed) {
                this.setState({
                  selectedProducts: this.state.selectedProducts.filter(
                    (pr) => pr !== product
                  ),
                  newSelection: this.state.selectedProducts.filter(
                    (pr) => pr !== product
                  ),
                })
              }
            }}
          >
            <div className={styles.removeButton}>
              <img className={styles.removeImage} src={Plus} alt="plus" />
            </div>
          </div>
        )}

        <div
          style={{
            color: this.state.hoveredProductIndex === idx ? '#E3E3E3' : '#000',
          }}
        >
          <div className={styles.productName}>{product}</div>
          <div className={styles.productLabel}>
            {this.products[product]['label']}
          </div>
        </div>
      </div>
    ))

    return (
      <>
        <div className={styles.container} id="comparison">
          <Sticky
            enabled={true}
            innerZ="1000"
            activeclassName={styles.activeModal}
            top={this.state.stickyHeaderTop}
            bottomBoundary="#comparison"
          >
            <div className={styles.titleBarContainer}>
              <div
                className={styles.titleBar}
                ref={this.titleBarRef}
                id="product-comparison-titlebar"
              >
                <div className={styles.addButtonContainer}>
                  <div
                    className={styles.addMoreButton}
                    onClick={this.openModal}
                  >
                    <span>
                      <img className={styles.arrow} src={Plus} alt="plus" />
                    </span>
                  </div>
                </div>
                <div className={styles.productHeader}>{comparisonTitleBar}</div>
              </div>
            </div>

            <div className={styles.mobileTitleBar}>
              {[0, 1].map((idx) => (
                <React.Fragment key={idx}>
                  {this.state.mobileSelectedProducts.length >= idx + 1 && (
                    <div
                      className={`${styles.selectedTile} ${styles.mobileTile}`}
                      onClick={this.openModal}
                      style={{
                        backgroundColor:
                          this.products[this.state.mobileSelectedProducts[idx]]
                            .selectionColor,
                      }}
                    >
                      <div className={styles.mobileTileTitle}>
                        {this.state.mobileSelectedProducts[idx]}
                      </div>
                      <div className={styles.mobileTileLabel}>
                        {
                          this.products[this.state.mobileSelectedProducts[idx]]
                            .label
                        }
                      </div>
                    </div>
                  )}
                  {this.state.mobileSelectedProducts.length < idx + 1 && (
                    <div
                      className={`${styles.mobileProductPicker} ${styles.mobileTile}`}
                      onClick={this.openModal}
                    >
                      <img
                        src={BlackPlus}
                        className={styles.blackPlus}
                        alt="plus"
                      />
                      <div>
                        <FormattedMessage id="cta.compare" />
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </Sticky>
          <div
            className={styles.comparisonContainer}
            onScroll={this.handleContainerScroll}
          >
            {specSections}
          </div>
        </div>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          className={styles.productPicker}
          overlayClassName={styles.productPickerOverlay}
          contentLabel="Example Modal"
          onAfterClose={this.onPickerClose}
        >
          <div className={styles.pickerHeader}>
            <div className={styles.pickerTitle}>
              {!isMobile && <FormattedMessage id="productComparison.select" />}
              {isMobile && (
                <FormattedMessage id="productComparison.selectShort" />
              )}
            </div>
            <img
              className={styles.closeButton}
              src={Close}
              onClick={this.closeModal}
              alt="close button"
            />
          </div>
          <div className={styles.pickerBody}>
            {this.productOrder.map((pr, idx) => (
              <ProductTile
                key={idx}
                productName={pr}
                maxAllowed={!isMobile ? this.maxAllowed : this.maxMobileAllowed}
                newSelection={
                  !isMobile
                    ? this.state.newSelection
                    : this.state.newMobileSelection
                }
                productIcon={this.products[pr].icon}
                productDesc={this.products[pr].desc}
                selected={
                  !isMobile
                    ? this.state.newSelection.indexOf(pr) > -1
                    : this.state.newMobileSelection.indexOf(pr) > -1
                }
                productLabel={this.products[pr].label}
                productColor={this.products[pr].selectionColor}
                onSelect={() => {
                  if (
                    !isMobile &&
                    this.state.newSelection.length < this.maxAllowed
                  ) {
                    this.setState({
                      newSelection: [...this.state.newSelection, pr],
                    })
                  }

                  if (
                    isMobile &&
                    this.state.newMobileSelection.length < this.maxMobileAllowed
                  ) {
                    this.setState({
                      newMobileSelection: [
                        ...this.state.newMobileSelection,
                        pr,
                      ],
                    })
                  }
                }}
                style={{
                  cursor:
                    this.state.newSelection.length > this.maxAllowed
                      ? 'not-allowed'
                      : 'pointer',
                }}
                onDeselect={() => {
                  if (!isMobile) {
                    const index = this.state.newSelection.indexOf(pr)
                    if (index > -1) {
                      this.setState({
                        newSelection: this.state.newSelection.filter(
                          (selection) => selection !== pr
                        ),
                      })
                    }
                  }

                  if (isMobile) {
                    const index = this.state.newMobileSelection.indexOf(pr)
                    if (index > -1) {
                      this.setState({
                        newMobileSelection:
                          this.state.newMobileSelection.filter(
                            (selection) => selection !== pr
                          ),
                      })
                    }
                  }
                }}
              />
            ))}

            {isMobile && (
              <div className={styles.selectedSection}>
                <div className={styles.selectedSectionTitle}>
                  <FormattedMessage id="productComparison.sensorsSelected" />
                </div>
                <div className={styles.selectedSensors}>
                  {this.state.newMobileSelection.map((pr, idx) => (
                    <ProductTile
                      key={idx}
                      productName={pr}
                      maxAllowed={this.maxAllowed}
                      newSelection={this.state.newSelection}
                      productIcon={this.products[pr].icon}
                      productDesc={this.products[pr].desc}
                      selected={true}
                      productLabel={this.products[pr].label}
                      productColor={this.products[pr].selectionColor}
                      hideSelectedIndicator={true}
                      onSelect={() => {}}
                      onDeselect={() => {}}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className={styles.pickerFooter}>
            {!isMobile && (
              <div className={styles.selectionIndicator}>
                <span>
                  {this.state.newSelection.length}/5{' '}
                  <FormattedMessage id="productComparison.selected" />
                </span>
              </div>
            )}
            <div className={styles.actionBox}>
              {!isMobile && (
                <div
                  className={styles.cancelButton}
                  onClick={() => {
                    if (!isMobile) {
                      this.setState({
                        newSelection: this.state.selectedProducts,
                      })
                    } else {
                      this.setState({
                        newMobileSelection: this.state.newMobileSelection,
                      })
                    }
                    this.closeModal()
                  }}
                >
                  <FormattedMessage id="productComparison.cancel" />
                </div>
              )}

              <Button
                className={styles.compareButton}
                onClick={() => {
                  this.setState({
                    selectedProducts: this.state.newSelection,
                    mobileSelectedProducts: this.state.newMobileSelection,
                    modalIsOpen: false,
                  })
                }}
                style={{
                  width: isMobile ? '325px' : '191px',
                  background:
                    this.state.newSelection.length > 0 &&
                    this.state.newSelection.length <= 5
                      ? '#35459c'
                      : '#E3E3E3',
                  borderColor:
                    this.state.newSelection.length > 0 &&
                    this.state.newSelection.length <= 5
                      ? '#35459c'
                      : '#E3E3E3',
                  disabled:
                    this.state.newSelection.length > 0 &&
                    this.state.newSelection.length <= 5
                      ? false
                      : true,

                  outline: 'none',
                }}
              >
                <FormattedMessage id="productComparison.compare" />
              </Button>
            </div>
          </div>
        </Modal>

        {/* Image slider modal */}
        <Modal
          isOpen={this.state.imageSliderIsOpen}
          onRequestClose={this.closeImageSlider}
          className={styles.imageSlider}
          overlayClassName={styles.imageSliderOverlay}
          contentLabel="Image slider"
        >
          <div className={styles.imageSliderHeader}>
            <img
              className={styles.closeButton}
              src={Close}
              onClick={this.closeImageSlider}
              alt="close button"
            />
          </div>
          <div className={styles.imageSliderBody}>
            <div className={styles.thumbnails}>
              {!isMobile &&
                this.state.imagesForSlider.map((image, idx) => (
                  <div
                    key={idx}
                    className={styles.thumbnail}
                    onClick={() =>
                      this.setState({ imageSliderImageIndex: idx })
                    }
                  >
                    <GatsbyImage
                      image={image.src}
                      style={{ height: '100%', width: '100%' }}
                      alt={image?.description}
                    />
                    {this.state.imageSliderImageIndex === idx && (
                      <div className={styles.imageHighlighter}></div>
                    )}
                  </div>
                ))}
              <div className={styles.slider}>
                {!isMobile && (
                  <React.Fragment>
                    <img
                      src={LeftArrow}
                      className={styles.leftArrow}
                      onClick={this.prevImage}
                      alt="left arrow"
                    />
                    <img
                      src={RightArrow}
                      className={styles.rightArrow}
                      onClick={this.nextImage}
                      alt="right arrow"
                    />
                    <div className={styles.slide}>
                      {this.state.imageSliderImageIndex !== -1 &&
                        this.state.imageSliderImageIndex <
                          this.state.imagesForSlider.length && (
                          <GatsbyImage
                            image={
                              this.state.imagesForSlider[
                                this.state.imageSliderImageIndex
                              ].src
                            }
                            style={{ height: '100%', width: '100%' }}
                            alt={
                              this.state.imagesForSlider[
                                this.state.imageSliderImageIndex
                              ].description || ''
                            }
                          />
                        )}
                    </div>
                  </React.Fragment>
                )}
                {isMobile && (
                  <React.Fragment>
                    <Slider {...this.sliderSettings}>
                      {this.state.imagesForSlider.map((image, idx) => (
                        <div
                          className={styles.carousalImageContainer}
                          key={idx}
                        >
                          <GatsbyImage
                            image={this.state.imagesForSlider[idx].src}
                            style={{ height: '100%', width: '100%' }}
                            alt={
                              this.state.imagesForSlider[idx]?.description || ''
                            }
                          />
                        </div>
                      ))}
                    </Slider>
                  </React.Fragment>
                )}
              </div>
              <div className={styles.slideInfo}>
                {this.state.imageSliderImageIndex !== -1 &&
                  this.state.imageSliderImageIndex <
                    this.state.imagesForSlider.length &&
                  this.pointCloudMetaLabels.map((label, idx) => (
                    <div className={styles.slideInfoPair} key={idx}>
                      {/* <div className={styles.slideLabel}>{label}</div> */}
                      <div className={styles.slideValue}>
                        {
                          this.state.imagesForSlider[
                            this.state.imageSliderImageIndex
                          ].description.split(':')[idx]
                        }
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </Modal>
      </>
    )
  }
}
